<template>
    <div>
        <Heading>{{ $t('Registration') }}</Heading>

        <form @submit.prevent="submit" class="sm:w-1/2 text-center">
            <FormInput class="mb-6" :error="form.errors.login" v-model="form.login" :name="login"
                       :label="$t('Login')" icon="fa-solid fa-user"/>
            <FormInput v-model="form.password" :error="form.errors.password" :name="password" :label="$t('Password')"
                       icon="fa-solid fa-key"
                       type="password"/>

            <div class="text-xs mt-1 mb-6">
                <i class="fa-solid fa-triangle-exclamation"></i>
                {{ $t("Please use a secure username and password combination.") }}
            </div>

            <FormInput v-model="form.password_confirmation" :error="form.errors.password_confirmation" class="mb-6"
                       name="password_confirmation"
                       :label="$t('Confirm password')" icon="fa-solid fa-key"
                       type="password"/>
            <FormInput v-model="form.email" :error="form.errors.email" name="email" :label="$t('Email')"
                       icon="fa-solid fa-envelope" type="email"/>
            <div class="text-xs mt-1 mb-6">
               <div>
                    <i class="fa-solid fa-triangle-exclamation"></i>
                    {{ $t("Please use a valid email address. It will be use to recover your account.") }}
               </div>
                <div v-if="config.registration_registration_same_email">
                    <i class="fa-solid fa-circle-info"></i>
                    {{ $t("You can use the same email address to register multiple accounts.") }}
                </div>
            </div>

            <div v-if="form.errors.captcha_token" class="text-red-600">
                <i class="fa-solid fa-circle-exclamation"></i> {{ form.errors.captcha_token }}
            </div>

            <Button ref="submitButton" size="big" :disabled="form.processing">{{ $t('Register') }}</Button>
        </form>

    </div>
</template>

<script setup>
import FormInput from "@/Shared/FormInput"
import Heading from "@/Shared/Heading"
import Button from "@/Shared/Button"
import {useForm, usePage} from '@inertiajs/inertia-vue3'
import {computed, ref} from 'vue'

const config = computed(() => usePage().props.value.config)

const form = useForm({
    login: null,
    password: null,
    password_confirmation: null,
    email: null,
    captcha_token: null,
})

const submitButton = ref(null)

function submit() {
    submitButton.value.toggleLoading()

    let submitForm = (token) => {
        form.captcha_token = token;
        form.post(route('register'), {
            preserveScroll: true,
            onFinish: () => submitButton.value.toggleLoading()
        })
    };

    grecaptcha
        .execute(usePage().props.value.recaptcha_site_key, {action: "register"})
        .then(function (token) {
            submitForm(token);
        });
}
</script>
